import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

export default function CoWorkingFAQ() {
    const { t } = useTranslation();
    const contactUrl = process.env.REACT_APP_CONTACT_URL || 'https://example.com';
    const faqNewsRedirect = process.env.REACT_APP_FAQ_NEWS_REDIRECT || 'https://example.com';


    return (
        <div className="md:max-w-5xl lg:max-w-6xl mx-auto pb-6 space-y-10">
            <h1 className="text-5xl font-bold leading-[1.1] text-center">{t('cw_lp_faq.title')}</h1>

            {/* Section 1 */}
            <div>
                <h2 className="text-xl font-semibold mb-4">{t('cw_lp_faq.section1_title')}</h2>
                <div className="space-y-6">
                    <div>
                        <p className="font-bold">{t('cw_lp_faq.section1_q1')}</p>
                        <p className="mt-2 text-gray-700">{t('cw_lp_faq.section1_a1')}</p>
                    </div>
                    <div>
                        <p className="font-bold">{t('cw_lp_faq.section1_q2')}</p>
                        <p className="mt-2 text-gray-700">
                            <Trans
                                i18nKey="cw_lp_faq.section1_a2"
                                components={[
                                    <a
                                        href={faqNewsRedirect}
                                        className="text-blue-500 underline"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ]}
                            />
                        </p>
                        <p>{t('cw_lp_faq.section1_note1')}</p>
                        <p>{t('cw_lp_faq.section1_note2')}</p>
                        <p>{t('cw_lp_faq.section1_note3')}</p>
                    </div>
                    <div>
                        <p className="font-bold">{t('cw_lp_faq.section1_q3')}</p>
                        <p className="mt-2 text-gray-700">{t('cw_lp_faq.section1_a3')}</p>
                    </div>
                </div>
            </div>

            {/* Section 2 */}
            <div>
                <h2 className="text-xl font-semibold mb-4">{t('cw_lp_faq.section2_title')}</h2>
                <div className="space-y-6">
                    <div>
                        <p className="font-bold">{t('cw_lp_faq.section2_q1')}</p>
                        <p className="mt-2 text-gray-700">
                            <Trans
                                i18nKey="cw_lp_faq.section2_a1"
                                components={[
                                    <a
                                        href={faqNewsRedirect}
                                        className="text-blue-500 underline"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ]}
                            />
                        </p>
                    </div>
                </div>
            </div>

            {/* Section 3 */}
            <div>
                <h2 className="text-xl font-semibold mb-4">{t('cw_lp_faq.section3_title')}</h2>
                <div className="space-y-6">
                    {[
                        { question: 'section3_q1', answer: 'section3_a1' },
                        { question: 'section3_q2', answer: 'section3_a2' },
                        { question: 'section3_q3', answer: 'section3_a3' },
                        { question: 'section3_q4', answer: 'section3_a4' },
                        { question: 'section3_q5', answer: 'section3_a5' },
                        { question: 'section3_q6', answer: 'section3_a6' },
                        { question: 'section3_q7', answer: 'section3_a7' },
                        { question: 'section3_q8', answer: 'section3_a8' },
                        { question: 'section3_q9', answer: 'section3_a9' },
                    ].map(({ question, answer }, index) => (
                        <div key={index}>
                            <p className="font-bold">{t(`cw_lp_faq.${question}`)}</p>
                            <p className="mt-2 text-gray-700">{t(`cw_lp_faq.${answer}`)}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Section 4 */}
            <div>
                <h2 className="text-xl font-semibold mb-4">{t('cw_lp_faq.section4_title')}</h2>
                <div className="space-y-6">
                    {[
                        { question: 'section4_q1', answer: 'section4_a1' },
                        { question: 'section4_q2', answer: 'section4_a2' }
                    ].map(({ question, answer }, index) => (
                        <div key={index}>
                            <p className="font-bold">{t(`cw_lp_faq.${question}`)}</p>
                            <p className="mt-2 text-gray-700">{t(`cw_lp_faq.${answer}`)}</p>
                        </div>
                    ))}

                    <div>
                        <p className="font-bold">{t('cw_lp_faq.section4_q3')}</p>
                        <p className="mt-2 text-gray-700">
                            <Trans
                                i18nKey="cw_lp_faq.section4_a3"
                                components={[
                                    <a
                                        href={contactUrl}
                                        className="text-blue-500 underline"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ]}
                            />
                        </p>
                    </div>
                </div>
            </div>

            {/* Section 5 */}
            <div>
                <h2 className="text-xl font-semibold mb-4">{t('cw_lp_faq.section5_title')}</h2>
                <div className="space-y-6">
                    {[
                        { question: 'section5_q1', answer: 'section5_a1' },
                    ].map(({ question, answer }, index) => (
                        <div key={index}>
                            <p className="font-bold">{t(`cw_lp_faq.${question}`)}</p>
                            <p className="mt-2 text-gray-700">{t(`cw_lp_faq.${answer}`)}</p>
                        </div>
                    ))}
                    <div>
                        <p className="font-bold">{t(`cw_lp_faq.section5_q2`)}</p>
                        <p className="mt-2 text-gray-700">
                            <Trans
                                i18nKey="cw_lp_faq.section5_a2"
                                components={[
                                    <a
                                        href={contactUrl}
                                        className="text-blue-500 underline"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ]}
                            />
                        </p>
                    </div>
                </div>

            </div>
        </div>
    );
}
